import React, { useEffect, useState } from 'react';
import * as Request from '../../common/request';
import Page from '../../components/page';
import { DatePicker, List,ActionSheet, ImageUploader, Selection, Card, Form, Input, Space, Toast, Button } from 'antd-mobile'
import './index.less'

const PageModel = (props) => {
	const [list, setList] = useState([]);
	const [type, setType] = useState('');
	const [values, setValues] = useState('');
	const [area, setArea] = useState(0);
	const [areaList, setAreaList] = useState([]);
	const [visible_area, setVisibleArea] = useState(false);

	const getAreaList = async () => {
		const result = await Request.get({
			url: '/area/list'
		});
		if (!result) return;

		const list = result.data.list || [];
		let array = [{ "text": '全部', "key": '' }];
		for (let index = 0; index < list.length; index++) {
			array.push({ "text": list[index].areaName, "key": list[index].id });
		}
		setAreaList(array);
	};

	const getList = async (data={}) => {
		data.page = data.page || 0;
		console.log('切换tab', data);
		const result = await Request.get({
			url: '/allequipmentupkeep/list',
			data
		});
		if (!result) return;
		console.log(result);
		setList(result.data);
	};
	useEffect(() => {
		//获取街道列表
		getAreaList()
		const {type} = props;
		setType(type);
		getList({type});//获取所有数据的列表
	}, [123]);

	return (
		<Page {...{ page: 'alleuipment', showFooter: false, title: '运行情况' }} {...props}>
		<List>
			<List.Item onClick={() => setVisibleArea(true)} extra={values}>
				选择区域(默认全部)
			</List.Item>
			<ActionSheet
				visible={visible_area}
				actions={areaList}
				onClose={() => { setVisibleArea(false) }}
				onAction={action => {
					setVisibleArea(false)
					setValues(action.text)
					setArea(action.key)
					getList({subStreet: action.key, type});
				}}
			/>
			{
				list && list.length > 0 && list.map((item,index)=>{
					return  (
						<List.Item key={index} onClick={() => {
							console.log('=====',item.id);
							props.props.history.push('/allupkeepinfodetail/' + item.id)
						}}>
							<div className='div_title'>
								<div className='div_title_left'>公司名称:</div>
								<div className='div_title_right'>{item.enterpriseName}</div>
							</div>
							<div className='div_title'>
								<div className='div_title_left'>店铺名称:</div>
								<div className='div_title_right'>{item.companyName}</div>
							</div>
							<div className='div_title'>
								<div className='div_title_left'>地址:</div>
								<div className='div_title_right'>{item.address}</div>
							</div>
							<div className='div_title'>
								<div className='div_title_left'>设备:</div>
								<div className={`div_title_right ${type == 1 ? 'green' : 'activity'}`}>{item.equipmentName}</div>
							</div>
							<div className='div_title'>
								<div className='div_title_left'>保养情况:</div>
								<div className={`div_title_right ${type == 1 ? 'green' : 'activity'}`}>{type == 1 ? '已保养' : '未保养'}</div>
							</div>
						</List.Item>
					)
				})
			}
		</List>
		</Page>
	);
};

export default PageModel;
